import { render, staticRenderFns } from "./regulariza.vue?vue&type=template&id=4e16703c&"
import script from "./regulariza.vue?vue&type=script&lang=js&"
export * from "./regulariza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports